import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MobileService } from '@service/mobile.service';
import { StateService } from '@service/state.service';

@Component({
  selector: 'app-sso-failed',
  templateUrl: './sso-failed.component.html',
  styleUrls: ['./sso-failed.component.scss']
})
export class SsoFailedComponent implements OnInit {

  public message: string = ""

  private messages = {

    not_verified: "Deine Email Adresse ist bei Google noch nicht bestätigt. Bitte bestätige sie und probiere dann nochmal dich damit bei Zimmerer-Treff zu registrieren.",

    email_taken: 'Die Email die in deinem Facebook oder Google Account hinterlegt ist, ist bereits vergeben für einen User Account auf Zimmerer Treff. Versuche doch am besten einfach das Passwort bei uns zurücksetzen zu lassen. Das kannst du anklicken wenn du oben rechts auf "Login" klickst',

    no_email_provided: 'Zimmerer Treff braucht eine gültige Email Adresse von dir. In deinem Facebook Account ist keine Email Adresse hinterlegt oder du hast uns den Zugriff darauf nicht gestattet. Bitte registriere dich mit Google oder am besten direkt auf unserer Seite.',

    not_connected: "Leider ist ein interner Fehler aufgetreten. Bitte melde uns das an info@zimmerer-treffpunkt.com. Um das Problem kurzfristig zu umgehen registriere dich am besten direkt auf unserer Seite ohne Facebook / Google.",

    'apple-callback-user_cancelled_authorize': 'Du hast den Autorisierungsprozess abgebrochen.',

    'apple-authorization-code-exchange-failed': 'Beim Anmeldeprozess mit Apple ist etwas schiefgelaufen. Probiere es noch einmal oder kontaktiere den Support unter info@zimmerer-treffpunkt.com.',

    'apple-user-id-taken': 'Diese Apple ID ist bereits vergeben. Bitte kontaktiere den Support unter info@zimmerer-treffpunkt.com um das Problem aufzuklären.',

    'blacklisted-email': 'Leider ist etwas schief gelaufen.',

    'apple-user-id-not-found': 'Apple denkt, dass du bereits einen Account bei uns hast – wir können aber keinen mit deiner Apple ID finden. Du kannst den Support unter info@zimmerer-treffpunkt.com kontaktieren oder bei deinem Apple Account den Zugang für den Zimmerer-Treff entfernen.',
  }

  constructor(
    public MobileService: MobileService,
    private StateService: StateService,
    private ActivatedRoute: ActivatedRoute
  ) {
    this.ActivatedRoute.params.subscribe(params => {

      // if error code is not set -> die
      if (typeof params['e'] == "undefined" || params['e'] === null) {
        console.error("SsoFailedComponent no error code was sent")
        this.StateService.goto('/news')
        return
      }

      // if no message provided for error code -> die
      if (typeof this.messages[params['e']] == "undefined") {
        console.error("SsoFailedComponent no message for error code "+params['e']+" provided")
        this.StateService.goto('/news')
        return
      }

      this.message = this.messages[params['e']]
    })
  }

  ngOnInit() { }
}